import React from 'react';
import { CheckCircle } from 'lucide-react';
import { formatPrice } from '../utils/formatPrice';

const Pricing = ({ prices, onOrderClick }) => {
  return (
    <div id="preturi" className="max-w-6xl mx-auto py-16 px-4">
      <h2 className="text-3xl font-bold text-center mb-12">Taxa ANCPI inclusă, fără costuri ascunse</h2>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {/* Extras Carte Funciară */}
        <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-gray-200 hover:border-teal-500 transition-all">
          <h3 className="text-2xl font-bold mb-2">Extras Carte Funciară</h3>
          <p className="text-sm text-gray-600 mb-4">Taxa ANCPI inclusă</p>
          <p className="text-5xl font-bold text-gray-900 mb-6">
            {formatPrice(prices.basic)} lei<span className="text-lg text-gray-500"> TVA inclus</span>
          </p>
          
          <ul className="space-y-3 mb-6">
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document cu semnătură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document eliberat original</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Notificare GRATUITĂ prin SMS și email despre stadiul comenzii</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Factură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Suport telefonic L-V 09:00-17:00</span>
            </li>
          </ul>
        </div>

        {/* Extras Plan Cadastral */}
        <div className="bg-white rounded-xl shadow-lg p-8 border-2 border-gray-200 hover:border-teal-500 transition-all">
          <h3 className="text-2xl font-bold mb-2">Extras pe Ortofotoplan</h3>
          <p className="text-sm text-gray-600 mb-4">Taxa ANCPI inclusă</p>
          <p className="text-5xl font-bold text-gray-900 mb-6">
            {formatPrice(prices.withHistory)} lei<span className="text-lg text-gray-500"> TVA inclus</span>
          </p>

          <ul className="space-y-3 mb-6">
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document cu semnătură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Document eliberat original</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Notificare GRATUITĂ prin SMS și email despre stadiul comenzii</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Factură electronică</span>
            </li>
            <li className="flex items-start">
              <CheckCircle className="w-5 h-5 text-emerald-600 mr-2 flex-shrink-0 mt-0.5" />
              <span className="text-sm">Suport telefonic L-V 09:00-17:00</span>
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default Pricing;
